var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("deliveryInfo.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("deliveryInfo.blNo"),
                            prop: "blNo",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholder.blNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.blNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "blNo", $$v)
                              },
                              expression: "form.blNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "30px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", { staticClass: "warm-tips" }, [
                _vm._v("\n          " + _vm._s(_vm.$t("deliveryInfo.tips_1"))),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("deliveryInfo.tips_2")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.isResult
      ? _c(
          "div",
          { staticClass: "result-container" },
          [
            _c("h4", [_vm._v(_vm._s(_vm.$t("deliveryInfo.baseInfo")))]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "12px",
                  "background-color": "white",
                  padding: "16px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "center" } },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _vm._v(_vm._s(_vm.$t("deliveryInfo.blNo"))),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _vm._v(_vm._s(_vm.baseData.blNo)),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _vm._v(_vm._s(_vm.$t("deliveryInfo.vessel"))),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _vm._v(
                        _vm._s(_vm.baseData.inVesselCode) +
                          _vm._s(_vm.baseData.inVoyageNo) +
                          _vm._s(_vm.baseData.inVoyageLeg)
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "center" } },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _vm._v(_vm._s(_vm.$t("deliveryInfo.eta"))),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _vm._v(_vm._s(_vm.baseData.arrivalDate)),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 4 } }, [
                      _vm._v(_vm._s(_vm.$t("deliveryInfo.deliverableDate"))),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _vm._v(_vm._s(_vm.baseData.deliverableDate)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("h4", [_vm._v(_vm._s(_vm.$t("deliveryInfo.feeInfo")))]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "80%" },
                attrs: {
                  data: _vm.tableFeeData,
                  border: "",
                  "show-summary": "",
                  "summary-method": _vm.getSummaries,
                  size: "small",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "chargeCode",
                    label: _vm.$t("deliveryInfo.chargeCode"),
                    "min-width": "30%",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "containerType",
                    label: _vm.$t("deliveryInfo.containerType"),
                    "min-width": "30%",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "rate",
                    label: _vm.$t("deliveryInfo.rate"),
                    "min-width": "30%",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " + _vm._s(scope.row.rate) + " "
                            ),
                            scope.row.chargeCode !== "OF"
                              ? _c("span", [_vm._v(_vm._s(scope.row.currency))])
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1582874168
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "containerNum",
                    label: _vm.$t("deliveryInfo.containerQuantity"),
                    "min-width": "25%",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "currency",
                    label: _vm.$t("deliveryInfo.amount"),
                    "min-width": "20%",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  isNaN(scope.row.amount)
                                    ? scope.row.amount
                                    : _vm.toMoney(scope.row.amount)
                                ) +
                                " "
                            ),
                            scope.row.chargeCode !== "OF"
                              ? _c("span", [_vm._v(_vm._s(scope.row.currency))])
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    529255491
                  ),
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }